import FilterField from './FilterField.js';

class NestedFilter {
	constructor(input) {
		this.join = ko.observable('AND');
		this.filters = ko.observableArray([]);

		this.filterString = ko.pureComputed(() => {
			const join = this.join();
			const filters = this.filters();

			let filterString = filters.map(f => f.filterString()).join(` ${join} `);
			return `( ${filterString} )`;
		});

		if (input)
			this.set(input);
	}

	set(input) {
		input = ko.mapping.toJS(input ?? {});

		let filterSource;
		if (input instanceof Array)
		{
			this.join('AND');
			filterSource = input;
		}
		else
		{
			this.join(input.join?.toUpperCase() ?? 'AND');
			filterSource = input.filter ?? input.filters ?? [];
		}

		this.filters(filterSource.map(f => {
			if (f.filters?.length > 0 || f.join)
				return new NestedFilter(f);
			else
				return new FilterField(f);
		}));
	}

	get() {
		return {
			join: this.join(),
			filter: this.filters()?.map(f => f.get()) ?? []
		};
	}

	find_filter_field(name, operator) {
		return this.filters().find(f => f.field() == name && (!operator || f.operator() == operator));
	}

	set_filter_field(name, operator, value) {
		let ff = this.filters().find(f => f.field() == name && (!operator || f.operator() == operator));
		if (!ff)
		{
			ff = new FilterField();
			ff.field(name);
			ff.operator(operator);
			this.filters.push(ff);
		}
		ff.value(value);
	}

	remove_filter_field(name, operator) {
		let filters = this.filters();
		let idx = -1;
		for (let i = 0; i < filters.length && idx < 0; i++) {
			let f = filters[i];
			if (f.field() == name && (!operator || f.operator() == operator))
				idx = i;
		}
		if (idx < 0)
			return;

		filters.splice(idx, 1);
		this.filters(filters);
	}



	add_filter(join_type) {
		let filter;
		if (join_type)
		{
			filter = new NestedFilter({ join: join_type ?? 'AND' });
			this.filters.push(filter);
		}
		else
		{
			filter = new FilterField();
			this.filters.push(filter);
		}
		return filter;
	}

	remove_filter(filter) {
		let filters = this.filters();

		const idx = filters.indexOf(filter);
		if (idx >= 0)
		{
			filters.splice(idx, 1);
			this.filters(filters);
		}
	}
}
export default NestedFilter;
